import { type CoreBookingStatus, type CoreBooking } from '@flecto/types'
import { useBookingStatus } from '@flecto/utils'

import { Badge, type BadgeProps } from '..'

export type BadgeBookingStatusProps = Omit<BadgeProps, 'children'> & {
  booking?: CoreBooking
  forceStatus?: CoreBookingStatus
}

export function BadgeBookingStatus({
  booking,
  forceStatus,
  ...props
}: BadgeBookingStatusProps) {
  const { bookingStatus, allStatuses } = useBookingStatus({ booking })

  const status = forceStatus ? allStatuses[forceStatus] : bookingStatus

  return (
    <Badge {...props} color={status.color} withDot>
      {status.label}
    </Badge>
  )
}
